export enum RpColumnRenderType {
  COMPANY_LINK = 'COMPANY_LINK',
  DATE = 'DATE',
  COLORED = 'COLORED',
  METRIC_CHANGE_INDICATOR = 'METRIC_CHANGE_INDICATOR',
  DEFAULT = 'DEFAULT',
  CS_VIEW = 'CS_VIEW',
  IMPLIED = 'IMPLIED',
  CREDIT = 'CREDIT',
  COVERAGE = 'COVERAGE',
  SELECTION = 'SELECTION',
  ROUNDED = 'ROUNDED',
  PERCENTAGE = 'PERCENTAGE',
  SCORE = 'SCORE',
  CORE_SCORE = 'CORE_SCORE',
  CORE_SCORE_OUTLOOK = 'CORE_SCORE_OUTLOOK',
}

export interface RpColumn {
  group: string;
  data_field: string;
  es_field: string;
  short_name?: string;
  canAccess?: boolean;
  description?: string;
  renderType: RpColumnRenderType;
  colId?: string;
  meta?: Record<string, any>;
}
